// Centered product carousel for the featured collection section ("Centered carousel" setting).
// The track is a native horizontal scroller with snap points (so touch swiping works); the arrows
// move it one product at a time and the counter shows the current position, e.g. "1 / 2".
if (!customElements.get('featured-carousel')) {
  customElements.define(
    'featured-carousel',
    class FeaturedCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.featured-carousel__track');
        this.slides = Array.from(this.querySelectorAll('.featured-carousel__slide'));
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.currentElement = this.querySelector('.slider-counter--current');
        this.totalElement = this.querySelector('.slider-counter--total');
        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.prevButton.addEventListener('click', () => this.go(-1));
        this.nextButton.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        new ResizeObserver(() => this.update()).observe(this.track);
        this.update();
      }

      // Distance from one product to the next (card width + gap).
      get step() {
        if (this.slides.length < 2) return this.track.clientWidth || 1;
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft || 1;
      }

      // Products fully visible at once: 3 on desktop, 2 on mobile (set in CSS).
      get perPage() {
        const gap = this.step - (this.slides[0]?.offsetWidth || 0);
        return Math.max(1, Math.round((this.track.clientWidth + gap) / this.step));
      }

      get pages() {
        return Math.max(1, this.slides.length - this.perPage + 1);
      }

      get index() {
        return Math.min(this.pages - 1, Math.max(0, Math.round(this.track.scrollLeft / this.step)));
      }

      go(direction) {
        const target = Math.min(this.pages - 1, Math.max(0, this.index + direction));
        this.track.scrollTo({ left: target * this.step });
      }

      update() {
        const pages = this.pages;
        const index = this.index;
        if (this.currentElement) this.currentElement.textContent = index + 1;
        if (this.totalElement) this.totalElement.textContent = pages;
        this.prevButton.disabled = index <= 0;
        this.nextButton.disabled = index >= pages - 1;
        this.toggleAttribute('data-single-page', pages <= 1);
      }
    }
  );
}
